import { useMemo } from "react";
import { createSlice } from "@reduxjs/toolkit";

import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";

import { creatorsSaga, editCreatorSaga } from "./saga";
//
export const initialState = {
  editCreator: {
    data: null,
    loading: false,
    error: null
  },
  updateCreator: {
    loading: false,
    error: null,
    success: false
  }
};

export const EditCreatorSlice = createSlice({
  name: "editCreator",
  initialState,
  reducers: {
    // =========================
    // GET CREATOR BY ID
    // =========================
    getCreatorById: (state) => {
      state.editCreator.loading = true;
      state.editCreator.error = null;
    },
    getCreatorByIdSuccess: (state, action) => {
      state.editCreator.loading = false;
      state.editCreator.data = action.payload;
    },
    getCreatorByIdFailure: (state, action) => {
      state.editCreator.loading = false;
      state.editCreator.error = action.payload;
    },

    // =========================
    // UPDATE CREATOR
    // =========================
    updateCreator: (state) => {
      state.updateCreator.loading = true;
      state.updateCreator.error = null;
      state.updateCreator.success = false;
    },
    updateCreatorSuccess: (state) => {
      state.updateCreator.loading = false;
      state.updateCreator.success = true;
    },
    updateCreatorFailure: (state, action) => {
      state.updateCreator.loading = false;
      state.updateCreator.error = action.payload;
    },

    clearCreatorState: (state) => {
      state.editCreator.data = null;
      state.editCreator.error = null;
      state.editCreator.loading = false;
      state.updateCreator.success = false;
    }
  }
});

// custom hooks
export const useEditCreatorSlice = () => {
  useInjectReducer(EditCreatorSlice.name, EditCreatorSlice.reducer);
  useInjectSaga(EditCreatorSlice.name, editCreatorSaga);

  const actions = useMemo(() => EditCreatorSlice.actions, []);
  return { actions };
};

export const { actions: editCreatorActions } = EditCreatorSlice;
export default EditCreatorSlice.reducer;
